import React from "react";
import { X } from "lucide-react";
import { useProductUpdateProgress } from "../hooks/useProductUpdates";

const StatRow = ({ label, value }) => (
  <div className="flex justify-between py-2 border-b border-gray-100 last:border-0">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-sm font-semibold text-gray-900">{value}</span>
  </div>
);

const ProductUpdateReportModal = ({ isOpen, onClose, uuid }) => {
  const { data, isLoading } = useProductUpdateProgress(uuid, { pollWhileSending: true });
  const campaign = data?.data?.campaign;
  const jobRun = data?.data?.jobRun;

  if (!isOpen) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50 transition-opacity">
      <div className="mx-4 w-full max-w-lg bg-white rounded-2xl shadow-2xl">
        <div className="flex justify-between items-center px-6 py-4 bg-gray-50 border-b rounded-t-2xl">
          <h3 className="text-lg font-semibold text-gray-900">Send Report</h3>
          <button onClick={onClose} className="text-gray-400 transition-colors hover:text-gray-600">
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="px-6 py-5">
          {isLoading ? (
            <p className="text-sm text-gray-500">Loading...</p>
          ) : !jobRun ? (
            <p className="text-sm text-gray-500">
              This campaign hasn't been sent yet - nothing to report.
            </p>
          ) : (
            <div>
              <StatRow label="Status" value={jobRun.status} />
              <StatRow label="Total recipients" value={jobRun.totalItems ?? "—"} />
              <StatRow label="Sent" value={jobRun.succeededCount} />
              <StatRow label="Failed" value={jobRun.failedCount} />
              <StatRow label="Processed" value={jobRun.processedCount} />
              <StatRow
                label="Started"
                value={jobRun.startedAt ? new Date(jobRun.startedAt).toLocaleString() : "—"}
              />
              <StatRow
                label="Completed"
                value={jobRun.completedAt ? new Date(jobRun.completedAt).toLocaleString() : "—"}
              />

              {jobRun.errorSummary?.length > 0 && (
                <div className="mt-4">
                  <p className="mb-2 text-xs font-bold text-red-600 uppercase">
                    Recent errors ({jobRun.errorSummary.length})
                  </p>
                  <div className="overflow-y-auto space-y-1 max-h-40">
                    {jobRun.errorSummary.map((err, i) => (
                      <p key={i} className="p-2 text-xs text-red-700 bg-red-50 rounded">
                        {err.identifier}: {err.message}
                      </p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductUpdateReportModal;
